import { useContext } from "react";
import { ConfigContext } from "../../context/configContext";
import { useNavigate } from "react-router-dom";


const Redes = () => {

    const { about } = useContext(ConfigContext);



    return (
        <div className="redes">
            <span>Follow me!</span>
            <ul className="nav" >

                <li
                    className="nav-item facebook"
                >
                    <a
                        href={about.facebook}
                        target="_blank"
                        rel="noopener noreferrer" >
                        <i className="bi bi-facebook"></i>
                    </a>
                </li>
                <li className="nav-item github">
                    <a
                        href={about.github}
                        target="_blank"
                        rel="noopener noreferrer" >

                        <i className="bi bi-github"></i>
                    </a>
                </li>
                <li className="nav-item linkedin">
                    <a href={about.linkedin}
                        target="_blank"
                        rel="noopener noreferrer" >

                        <i className="bi bi-linkedin"></i>
                    </a>
                </li>
                <li className="nav-item twitter">
                    <a href={about.twitter}
                        target="_blank"
                        rel="noopener noreferrer" >

                        <i className="bi bi-twitter"></i>
                    </a>
                </li>
                <li className="nav-item instagram">
                    <a href={about.instagram}
                        target="_blank"
                        rel="noopener noreferrer" >
                        <i className="bi bi-instagram"></i>
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default Redes;